module.exports = __webpack_public_path__ + "img/dhfesta_logo_eng_2.d0a01dcd.png";